import React from 'react'
import PropTypes from 'prop-types'
import track from 'App/helpers/track'

export default class Text extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
    fieldType: PropTypes.string,
    passProps: PropTypes.object,
    placeholder: PropTypes.node,
    errorMessage: PropTypes.node,
    disabled: PropTypes.bool,
    track: PropTypes.object,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    className: PropTypes.string,
    pattern: PropTypes.string,
    fieldName: PropTypes.string
  }

  static defaultProps = {
    fieldType: 'text',
    value: ''
  }

  trackBlur() {
    const traceableEvent = {
      action: `entered-${this.props.fieldName}`,
      ...this.props.track
    }
    if (this.props.track) return track(traceableEvent)
  }

  render() {
    return (
      <div>
        <div className="os-input-container">
          <input
            ref={ref => (this.input = ref)}
            onBlur={() => {
              if (this.props.onBlur) {
                this.props.onBlur()
              }
              this.trackBlur()
            }}
            onFocus={() => {
              if (this.props.onFocus) this.props.onFocus()
            }}
            className={`os-input-text ${this.props.className ? this.props.className : ''}`}
            type={this.props.fieldType}
            value={this.props.value}
            placeholder={this.props.placeholder}
            onChange={event => this.props.onChange(event.target.value)}
            disabled={this.props.disabled}
            pattern={this.props.pattern ? this.props.pattern : '[a-zA-z0-9 ]+'}
            {...this.props.passProps}
          />
        </div>
        <div className="os-input-error">{this.props.errorMessage}</div>
      </div>
    )
  }
}
